import React, {useCallback} from 'react';
import {CustomTextField} from 'app/components/match/liveResult/CustomNumberTextField';
import {GridElement} from 'app/components/match/liveResult/updateScorer/sharedStyles';
import {Inputs, Player} from 'app/components/match/liveResult/updateScorer/sharedTypes';
import {MenuItem, TextFieldProps} from '@mui/material';
import {Control, Controller, FieldError} from 'react-hook-form';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  overflow: hidden;
  width: 100%;
`;

const JerseyNumber = styled.div`
  flex: 0 0 28px;
  text-align: center;
  padding-right: 4px;
`;

const Name = styled.div`
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

interface PlayerSelectProps {
  error: FieldError | undefined;
  isLoading: boolean;
  players: Player[];
  show: boolean;
  control: Control<Inputs, any>;
  name: keyof Inputs;
}

type Props = PlayerSelectProps & Omit<TextFieldProps, 'error'>;

export default function PlayerSelect({isLoading, players, show, error, control, ...props}: Props) {
  const getOptions = useCallback(() => {
    if (isLoading) {
      return [<MenuItem value='unbekannt'>Spieler werden geladen...</MenuItem>];
    }
    const playerOptions = players.map(player => {
      const playerName = `${player.lastName} ${player.firstName}`;
      return (
        <MenuItem key={player.id} value={player.id}>
          <Container>
            <JerseyNumber>{player.jerseyNumber || ''}</JerseyNumber>
            <Name>{playerName}</Name>
          </Container>
        </MenuItem>
      );
    });
    return [
      <MenuItem key='unbekannt' value='unbekannt'>
        <Container>
          <JerseyNumber />
          <Name>Unbekannt</Name>
        </Container>
      </MenuItem>,
      ...playerOptions,
    ];
  }, [players, isLoading]);

  const options = getOptions();

  return show ? (
    <GridElement>
      <Controller
        control={control}
        name={props.name}
        render={({field}) => (
          <CustomTextField
            select
            error={!!error}
            fullWidth={true}
            variant='outlined'
            size='small'
            helperText={error?.message ?? ''}
            {...field}
            {...props}>
            {options}
          </CustomTextField>
        )}
      />
    </GridElement>
  ) : (
    <GridElement />
  );
}
